'use client';

import { useEffect, useState, useRef } from 'react';
import './styles/default.scss';
import { usePathname, useSearchParams } from 'next/navigation';
import { getTransactionHistoryData } from '@/logic/transaction-history';

const sanitizePage = (htmlText: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    // removes Close Window buttons
    const buttons = doc.querySelectorAll('input[type="button"]');
    buttons.forEach((btn) => btn.remove());
    // avoids nesting html components
    const sanitizedData = doc.querySelector('body')?.innerHTML;
    return sanitizedData;
};

export const TransactionHistory = () => {
    const [isLoading, setIsLoading] = useState(true);
    const pathname = usePathname();
    const params = useSearchParams().toString();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        getTransactionHistoryData(pathname, params)
            .then((res) => {
                if (res?.type === 'redirect') {
                    window.location.replace(res?.data);
                } else {
                    ref.current!.innerHTML = sanitizePage(res?.data) || res?.data;
                }
            })
            .catch(() => {
                ref.current!.innerHTML = 'The game round details are currently not available. Please try again later.';
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div id="data-transaction-history">
            {isLoading && 'Loading...'}
            <div ref={ref}></div>
        </div>
    );
};
